import { render, staticRenderFns } from "./createPersonalInformation.vue?vue&type=template&id=1735f232"
import script from "./createPersonalInformation.vue?vue&type=script&lang=ts"
export * from "./createPersonalInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports